import { render, staticRenderFns } from "./Temperatura.vue?vue&type=template&id=70df109c&scoped=true&"
import script from "./Temperatura.vue?vue&type=script&lang=js&"
export * from "./Temperatura.vue?vue&type=script&lang=js&"
import style0 from "./Temperatura.vue?vue&type=style&index=0&id=70df109c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df109c",
  null
  
)

export default component.exports